import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type Serie from '../../interfaces/pieces/mouvements/serie';

const getSeries = (params: URLSearchParams) =>
	request.get<unknown, TemplateRequestGet<Serie>>(
		`/api/finances/comptabilite/piecescomptables/series?all=true&${params?.toString()}`,
	);

export default getSeries;
